// extracted by mini-css-extract-plugin
export default {"root":"ErrorString_root__7EiNV","error":"ErrorString_error__1Z2WW","placeHolderShimmer":"ErrorString_placeHolderShimmer__kOnNS"};